import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options } from '@apexdesigner/schema-tools';

export const packageEntitlement = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    kind: options([
      {
        value: 'Standard Catalog',
        name: 'Standard Catalog',
        description:
          'Covers every Standard-tier package, by tier rather than pattern',
      },
      {
        value: 'Named Packages',
        name: 'Named Packages',
        description: 'Covers Restricted packages matching the name pattern',
      },
    ])
      .nullable()
      .optional()
      .describe('Kind - What this entitlement grants'),

    packageNamePattern: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Package Name Pattern - Exact name or scope wildcard, required for Named Packages grants',
      ),

    expiresAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe(
        'Expires At - Tied to the license that granted this entitlement',
      ),

    source: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Source - Free text identifying the license or order that granted it',
      ),

    userId: z.number().hidden().describe('Foreign key to User'),

    user: belongsTo('User'),
  })
  .describe(
    'A grant letting one user read either the standard catalog or specific restricted packages.',
  )
  .as('PackageEntitlement');

export { packageEntitlement as packageEntitlementSchema };
